var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRett(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135443",
    "data-name": "Group 135443",
    transform: "translate(-570 -702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135384",
    "data-name": "Group 135384",
    transform: "translate(439 51)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15500",
    "data-name": "Ellipse 15500",
    cx: 101,
    cy: 101,
    r: 101,
    transform: "translate(131 651)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "requirements",
    transform: "translate(599 720.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135442",
    "data-name": "Group 135442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135390",
    "data-name": "Group 135390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135389",
    "data-name": "Group 135389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135388",
    "data-name": "Group 135388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505684",
    "data-name": "Path 505684",
    d: "M107.769,4h-73.5L6,32.269V151a11.308,11.308,0,0,0,11.308,11.308h90.462A11.308,11.308,0,0,0,119.077,151V15.308A11.308,11.308,0,0,0,107.769,4Z",
    transform: "translate(-6 -4)",
    fill: "#fab400"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135393",
    "data-name": "Group 135393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135392",
    "data-name": "Group 135392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135391",
    "data-name": "Group 135391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505685",
    "data-name": "Path 505685",
    d: "M6,32.269H22.962A11.308,11.308,0,0,0,34.269,20.962V4Z",
    transform: "translate(-6 -4)",
    fill: "#dc9600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135409",
    "data-name": "Group 135409",
    transform: "translate(124.385 11.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135396",
    "data-name": "Group 135396",
    transform: "translate(0 22.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135395",
    "data-name": "Group 135395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135394",
    "data-name": "Group 135394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505686",
    "data-name": "Path 505686",
    d: "M50,16H72.615V117.769H50Z",
    transform: "translate(-50 -16)",
    fill: "#00a0c8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135399",
    "data-name": "Group 135399",
    transform: "translate(0 124.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135398",
    "data-name": "Group 135398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135397",
    "data-name": "Group 135397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505687",
    "data-name": "Path 505687",
    d: "M72.615,52H50l5.654,11.308H66.962Z",
    transform: "translate(-50 -52)",
    fill: "#f0c8a0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135402",
    "data-name": "Group 135402",
    transform: "translate(5.654 135.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135401",
    "data-name": "Group 135401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135400",
    "data-name": "Group 135400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505688",
    "data-name": "Path 505688",
    d: "M52,56l3.127,6.25a2.827,2.827,0,0,0,5.057,0L63.308,56Z",
    transform: "translate(-52 -56)",
    fill: "#0a5078"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135405",
    "data-name": "Group 135405",
    transform: "translate(0 16.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135404",
    "data-name": "Group 135404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135403",
    "data-name": "Group 135403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505689",
    "data-name": "Path 505689",
    d: "M50,14H72.615v5.654H50Z",
    transform: "translate(-50 -14)",
    fill: "#f0f0f0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135408",
    "data-name": "Group 135408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135407",
    "data-name": "Group 135407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135406",
    "data-name": "Group 135406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505690",
    "data-name": "Path 505690",
    d: "M66.962,8H55.654A5.652,5.652,0,0,0,50,13.654V24.962H72.615V13.654A5.652,5.652,0,0,0,66.962,8Z",
    transform: "translate(-50 -8)",
    fill: "#0a5078"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135412",
    "data-name": "Group 135412",
    transform: "translate(28.269 19.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135411",
    "data-name": "Group 135411",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135410",
    "data-name": "Group 135410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505691",
    "data-name": "Path 505691",
    d: "M69.712,33.615H68.258a2.9,2.9,0,0,1-2.7-1.993c-.246-.681-.52-1.346-.828-1.993a2.9,2.9,0,0,1,.5-3.322l1.029-1.029a2.824,2.824,0,0,0,0-4l-4-4a2.824,2.824,0,0,0-4,0l-1.029,1.029a2.9,2.9,0,0,1-3.322.5c-.647-.305-1.315-.582-1.993-.828a2.9,2.9,0,0,1-2-2.7V13.827A2.828,2.828,0,0,0,47.1,11H41.442a2.828,2.828,0,0,0-2.827,2.827V15.28a2.9,2.9,0,0,1-1.993,2.7c-.681.246-1.346.52-1.993.828a2.9,2.9,0,0,1-3.322-.5l-1.029-1.029a2.824,2.824,0,0,0-4,0l-4,4a2.824,2.824,0,0,0,0,4L23.313,26.3a2.9,2.9,0,0,1,.5,3.322c-.305.647-.582,1.315-.828,1.993a2.9,2.9,0,0,1-2.7,2H18.827A2.828,2.828,0,0,0,16,36.442V42.1a2.828,2.828,0,0,0,2.827,2.827H20.28a2.9,2.9,0,0,1,2.7,1.993c.246.681.52,1.346.828,1.993a2.9,2.9,0,0,1-.5,3.322L22.281,53.26a2.824,2.824,0,0,0,0,4l4,4a2.824,2.824,0,0,0,4,0L31.3,60.225a2.9,2.9,0,0,1,3.322-.5c.647.305,1.315.582,1.993.828a2.9,2.9,0,0,1,2,2.7v1.453a2.828,2.828,0,0,0,2.827,2.827H47.1a2.828,2.828,0,0,0,2.827-2.827V63.258a2.9,2.9,0,0,1,1.993-2.7c.681-.246,1.346-.52,1.993-.828a2.9,2.9,0,0,1,3.322.5l1.029,1.029a2.824,2.824,0,0,0,4,0l4-4a2.824,2.824,0,0,0,0-4l-1.029-1.029a2.9,2.9,0,0,1-.5-3.322c.305-.647.582-1.315.828-1.993a2.9,2.9,0,0,1,2.7-2h1.453A2.828,2.828,0,0,0,72.538,42.1V36.442A2.828,2.828,0,0,0,69.712,33.615ZM44.269,50.577A11.308,11.308,0,1,1,55.577,39.269,11.308,11.308,0,0,1,44.269,50.577Z",
    transform: "translate(-16 -11)",
    fill: "#dc9600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135415",
    "data-name": "Group 135415",
    transform: "translate(28.269 16.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135414",
    "data-name": "Group 135414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135413",
    "data-name": "Group 135413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505692",
    "data-name": "Path 505692",
    d: "M69.712,32.615H68.258a2.9,2.9,0,0,1-2.7-1.993c-.246-.681-.52-1.346-.828-1.993a2.9,2.9,0,0,1,.5-3.322l1.029-1.029a2.824,2.824,0,0,0,0-4l-4-4a2.824,2.824,0,0,0-4,0l-1.029,1.029a2.9,2.9,0,0,1-3.322.5c-.647-.305-1.315-.582-1.993-.828a2.9,2.9,0,0,1-2-2.7V12.827A2.828,2.828,0,0,0,47.1,10H41.442a2.828,2.828,0,0,0-2.827,2.827V14.28a2.9,2.9,0,0,1-1.993,2.7c-.681.246-1.346.52-1.993.828a2.9,2.9,0,0,1-3.322-.5l-1.029-1.029a2.824,2.824,0,0,0-4,0l-4,4a2.824,2.824,0,0,0,0,4L23.313,25.3a2.9,2.9,0,0,1,.5,3.322c-.305.647-.582,1.315-.828,1.993a2.9,2.9,0,0,1-2.7,2H18.827A2.828,2.828,0,0,0,16,35.442V41.1a2.828,2.828,0,0,0,2.827,2.827H20.28a2.9,2.9,0,0,1,2.7,1.993c.246.681.52,1.346.828,1.993a2.9,2.9,0,0,1-.5,3.322L22.281,52.26a2.824,2.824,0,0,0,0,4l4,4a2.824,2.824,0,0,0,4,0L31.3,59.225a2.9,2.9,0,0,1,3.322-.5c.647.305,1.315.582,1.993.828a2.9,2.9,0,0,1,2,2.7v1.453a2.828,2.828,0,0,0,2.827,2.827H47.1a2.828,2.828,0,0,0,2.827-2.827V62.258a2.9,2.9,0,0,1,1.993-2.7c.681-.246,1.346-.52,1.993-.828a2.9,2.9,0,0,1,3.322.5l1.029,1.029a2.824,2.824,0,0,0,4,0l4-4a2.824,2.824,0,0,0,0-4l-1.029-1.029a2.9,2.9,0,0,1-.5-3.322c.305-.647.582-1.315.828-1.993a2.9,2.9,0,0,1,2.7-2h1.453A2.828,2.828,0,0,0,72.538,41.1V35.442a2.828,2.828,0,0,0-2.827-2.827ZM44.269,49.577A11.308,11.308,0,1,1,55.577,38.269,11.308,11.308,0,0,1,44.269,49.577Z",
    transform: "translate(-16 -10)",
    fill: "#c80a50"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135422",
    "data-name": "Group 135422",
    transform: "translate(67.846 73.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135418",
    "data-name": "Group 135418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135417",
    "data-name": "Group 135417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135416",
    "data-name": "Group 135416"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15501",
    "data-name": "Ellipse 15501",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(0.154 -0.192)",
    fill: "#dc9600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135421",
    "data-name": "Group 135421",
    transform: "translate(5.653 8.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135420",
    "data-name": "Group 135420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135419",
    "data-name": "Group 135419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505693",
    "data-name": "Path 505693",
    d: "M40.481,49.962a2.819,2.819,0,0,1-2-.828L32.829,43.48a2.826,2.826,0,1,1,4-4l3.655,3.655,9.309-9.309a2.826,2.826,0,0,1,4,4L42.48,49.134A2.819,2.819,0,0,1,40.481,49.962Z",
    transform: "translate(-32 -33)",
    fill: "#0a5078"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135429",
    "data-name": "Group 135429",
    transform: "translate(67.846 113.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135425",
    "data-name": "Group 135425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135424",
    "data-name": "Group 135424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135423",
    "data-name": "Group 135423"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15502",
    "data-name": "Ellipse 15502",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(0.154 0.231)",
    fill: "#dc9600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135428",
    "data-name": "Group 135428",
    transform: "translate(5.653 8.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135427",
    "data-name": "Group 135427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135426",
    "data-name": "Group 135426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505694",
    "data-name": "Path 505694",
    d: "M40.481,63.962a2.819,2.819,0,0,1-2-.828L32.829,57.48a2.826,2.826,0,1,1,4-4l3.655,3.655,9.309-9.309a2.826,2.826,0,0,1,4,4L42.48,63.134A2.819,2.819,0,0,1,40.481,63.962Z",
    transform: "translate(-32 -47)",
    fill: "#0a5078"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135432",
    "data-name": "Group 135432",
    transform: "translate(11.308 87.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135431",
    "data-name": "Group 135431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135430",
    "data-name": "Group 135430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505695",
    "data-name": "Path 505695",
    d: "M58.058,40.654H12.827a2.827,2.827,0,1,1,0-5.654H58.058a2.827,2.827,0,0,1,0,5.654Z",
    transform: "translate(-10 -35)",
    fill: "#dc9600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135435",
    "data-name": "Group 135435",
    transform: "translate(11.308 101.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135434",
    "data-name": "Group 135434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135433",
    "data-name": "Group 135433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505696",
    "data-name": "Path 505696",
    d: "M35.442,45.654H12.827a2.827,2.827,0,1,1,0-5.654H35.442a2.827,2.827,0,1,1,0,5.654Z",
    transform: "translate(-10 -40)",
    fill: "#dc9600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135438",
    "data-name": "Group 135438",
    transform: "translate(11.308 141.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135437",
    "data-name": "Group 135437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135436",
    "data-name": "Group 135436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505697",
    "data-name": "Path 505697",
    d: "M35.442,59.654H12.827a2.827,2.827,0,1,1,0-5.654H35.442a2.827,2.827,0,1,1,0,5.654Z",
    transform: "translate(-10 -54)",
    fill: "#dc9600"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135441",
    "data-name": "Group 135441",
    transform: "translate(11.308 127.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135440",
    "data-name": "Group 135440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135439",
    "data-name": "Group 135439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505698",
    "data-name": "Path 505698",
    d: "M58.058,54.654H12.827a2.827,2.827,0,0,1,0-5.654H58.058a2.827,2.827,0,0,1,0,5.654Z",
    transform: "translate(-10 -49)",
    fill: "#dc9600"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRett);
export default __webpack_public_path__ + "static/media/rett.dd0b8cf2a7ae004054c55d2589abe845.svg";
export { ForwardRef as ReactComponent };